import $ from 'jquery';
import AccessibilityBar from '../modules/AccessibilityBar';
import Carousel from '../modules/Carousel';
import Dropdown from '../modules/Dropdown';
import Ellipsis from '../modules/Ellipsis';
import NewsPagination from '../modules/NewsPagination';
import Form from '../modules/Form';
import ToggleMenu from '../modules/ToggleMenu';
import YoutubeVideo from '../modules/YoutubeVideo';
import ScrollArea from '../modules/ScrollArea';

export default {
  init() {
    $(window).on('load', () => {
      Ellipsis.create('[data-ellipsis]');
      Carousel.create('[data-slider]');
      ScrollArea.create('[data-scrollarea]');
    });

    ToggleMenu.create('[data-menu-burger]');
    AccessibilityBar.create('[data-accessibility-bar]');
    Dropdown.create('[data-dropdown]');
    NewsPagination.create('[data-news-pagination]');
    Form.init();
    YoutubeVideo.create();
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/Common.js